<div id='orIntegrationsAreas'>
  <div class='or-content'>
    <div class='or-content-header'>
      <app-tabs [tabs$]="tabLinks$"></app-tabs>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
